module.exports = __webpack_public_path__ + "static/img/1.c944c28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/1.png
// module id = M3NB
// module chunks = 0